if (!customElements.get('mini-cart-info-slider')) {
  class MiniCartInfoSlider extends HTMLElement {
    connectedCallback() {
      this.init();
      this._unbindEditor = ThemeEditor.bind(this, () => this.init());
    }

    disconnectedCallback() {
      this._unbindEditor?.();
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    init() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      const swiperArea = this.querySelector('.cart-drawer__swiper') || document.querySelector('.cart-drawer__swiper');
      if (!swiperArea) return;

      this.slider = ThemeEditor.initSwiper(swiperArea, {
        direction: 'vertical',
        slidesPerView: 1,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 5000,
        }
      });
    }
  }

  customElements.define('mini-cart-info-slider', MiniCartInfoSlider);
}
